import { createReducer, on } from '@ngrx/store';

import * as ErrorActions from './error.actions';
import { Error, ErrorConfiguration, ErrorDisplay } from '../models/error.model';

export const errorFeatureKey = 'error';

export interface State {
  error: Error;
  errors: Array<Error>;
  errorConfig: ErrorConfiguration;
  errorDisplay: ErrorDisplay;
  errorSearch: string;
}

const initialState: State = {
  error: null,
  errors: [],
  errorConfig: { startDate: null, endDate: null, severities: [] },
  errorDisplay: ErrorDisplay.DEFAULT,
  errorSearch: ''
};

export const reducer = createReducer(
  initialState,
  on(ErrorActions.resetState, state => ({
    ...initialState
  })),
  on(ErrorActions.loadErrorsSuccess, (state, { errors }) => ({
    ...state,
    errors
  })),
  on(ErrorActions.saveError, (state, { error }) => ({
    ...state,
    error: state.error?.id === error?.id ? error : state.error,
    errors: [error, ...state.errors.filter(err => err.id !== error.id)]
  })),
  on(ErrorActions.selectError, (state, { error }) => ({
    ...state,
    error
  })),
  on(ErrorActions.syncNewError, (state, { error }) => ({
    ...state,
    errors: [error, ...state.errors]
  })),
  on(ErrorActions.updateConfig, (state, { errorConfig }) => ({
    ...state,
    errorConfig
  })),
  on(ErrorActions.searchTemplate, (state, { search }) => ({
    ...state,
    errorSearch: search
  })),
  on(ErrorActions.updateDisplay, (state, { display }) => ({
    ...state,
    errorDisplay: display
  }))
);
